import { generateHex, Logger, Second } from '@nu-art/ts-common';
import { BaseToastVariant } from './types.js';
import { ModuleFE_Toasting } from './ModuleFE_Toasting.js';
export class Toaster extends Logger {
    toastingKey;
    fallbackToastDuration = 4 * Second;
    muted = false;
    constructor(key, defaultDuration) {
        super('Toaster');
        if (defaultDuration)
            this.fallbackToastDuration = defaultDuration;
        this.toastingKey = key;
    }
    //######################### Mute Logic #########################
    setMute(mute) {
        this.muted = mute;
    }
    //######################### Toast Logic #########################
    toast(variant, properties) {
        if (this.muted)
            return;
        const model = {
            id: properties.id ?? generateHex(8),
            key: this.toastingKey,
            duration: properties.duration ?? this.fallbackToastDuration,
            variant: variant,
            title: properties.title,
            body: properties.body,
        };
        ModuleFE_Toasting.toast.open(model);
    }
    toastGeneral(properties) {
        this.toast(BaseToastVariant.General, properties);
    }
    toastInfo(properties) {
        this.toast(BaseToastVariant.Info, properties);
    }
    toastError(properties) {
        this.toast(BaseToastVariant.Error, properties);
    }
    toastSuccess(properties) {
        this.toast(BaseToastVariant.Success, properties);
    }
    getQueueLength() {
        const models = ModuleFE_Toasting.getModels()
            .filter(model => model.key === this.toastingKey);
        return models.length;
    }
}
//# sourceMappingURL=Toaster.js.map